import { motion, AnimatePresence } from 'framer-motion'
import { Helmet } from 'react-helmet'
import cn from 'clsx'

// Hooks
import { useMaxWidth } from '@tracklib/kit'

// Utils
import { DEFAULT_EASE } from '@constants'
import getScrollbarSize from 'lib/scrollbarSize'

import styles from './mobilemenu.css'

type MobileMenuProps = {
  children: JSX.Element | JSX.Element[]
  visible: boolean
  toggle: (state: boolean) => void
  side?: string
  width?: number
  className?: string
}

const MobileMenu = ({ children, visible, toggle, side, width = 300, className }: MobileMenuProps): JSX.Element => {
  const isSmall = useMaxWidth()

  const toggleMobileFilter = () => toggle(!visible)

  const spring = {
    type: 'spring',
    stiffness: 250,
    damping: width / 10,
    mass: 1,
    velocity: 0,
  }
  const linear = { duration: 0.3, ease: DEFAULT_EASE }
  return (
    <AnimatePresence>
      {(visible || !isSmall) && (
        <motion.div
          key="filter"
          className={cn(side === 'left' ? styles.menuLeft : styles.menu, className)}
          initial={{
            x: side === 'left' ? -width : width,
            transition: spring,
          }}
          animate={{ x: 0, transition: spring }}
          exit={{
            x: side === 'left' ? -width : width,
            transition: spring,
          }}
          style={isSmall ? { width } : {}}
        >
          {children}
        </motion.div>
      )}
      {visible && (
        <>
          <motion.button
            key="backdrop"
            onClick={toggleMobileFilter}
            className={styles.overlay}
            initial={{ opacity: 0, transition: linear }}
            animate={{ opacity: 1, transition: linear }}
            exit={{ opacity: 0, transition: linear }}
          />
          <Helmet>
            <body data-modal="true" style={`padding-right: ${getScrollbarSize()}px`} />
          </Helmet>
        </>
      )}
    </AnimatePresence>
  )
}

export default MobileMenu
